






























import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalEdit/types";
import NumberInput from "@/components/common/NumberInput.vue";
import ServicePublicMoney from "@/components/medicalEdit/specification/part/ServicePublicMoney.vue";

@Component({
  components: { NumberInput, ServicePublicMoney }
})
export default class ManagementMedical2 extends Vue {
  @Prop() tab!: MedicalSpecification;

  @Emit("changealltotal")
  public changealltotal() {
    return;
  }

  @Emit("changepublicmoney1")
  public changepublicmoney1() {
    return;
  }

  @Emit("changepublicmoney2")
  public changepublicmoney2() {
    return;
  }
}
